import { BooleanAnswer } from "./boolean-answer";

export declare class Answer {
  public answer?: BooleanAnswer;
}